import { useEffect, useState } from "react";
import { setCookie, getCookie } from "../Services/cookies";
import { ARIS_GAMES, ARIS_USERS, ARIS_ENVIRONMENTS, ARIS_ENGINE_REPLACEMENTS } from "./ArisServices";
import { Comm } from "../Services/Comm";

const Aris = ({ authenticated }) => {
    const comms = new Comm();

    const serviceIdCookie = getCookie("arisSerivceId") ? Number(getCookie("arisSerivceId")) : 25;

    const [serviceId, setServiceId] = useState(serviceIdCookie);
    const [testSite, setTestSite] = useState(`https://demo-kore${serviceIdCookie}.aristx-external.net/MandarinPalace`);

    const [userList, setUserList] = useState(ARIS_USERS.map((name, i) => `${i + 1} - ${name}`));
    const [userIndex, setUserIndex] = useState(getCookie("arisUserIndex") ? Number(getCookie("arisUserIndex")) : 0);

    const [gameList, setGameList] = useState([]);
    const [game, setGame] = useState(getCookie("arisGame") ? getCookie("arisGame") : ARIS_GAMES[0]);

    const [envList, setEnvList] = useState(ARIS_ENVIRONMENTS);
    const [env, setEnv] = useState(getCookie("arisEnv") ? getCookie("arisEnv") : ARIS_ENVIRONMENTS.AWS);

    const [safariBackup, setSafariBackup] = useState("");

    useEffect(() => {
        setCookie("arisUserIndex", userIndex);

        //only allow prod for Ed's account
        if (userIndex != 3) {
            const newCopy = JSON.parse(JSON.stringify(ARIS_ENVIRONMENTS));
            delete newCopy.Prod;
            setEnvList(newCopy);
        } else {
            setEnvList(ARIS_ENVIRONMENTS);
        }

        setEnv(ARIS_ENVIRONMENTS.AWS);

        setSafariBackup("");
    }, [userIndex]);

    useEffect(() => {
        setCookie("arisSerivceId", serviceId);
        setSafariBackup("");
    }, [serviceId]);

    useEffect(() => {
        setCookie("arisGame", game);
        setSafariBackup("");
    }, [game]);

    useEffect(() => {
        setCookie("arisEnv", env);
        setSafariBackup("");
    }, [env]);

    useEffect(() => {
        const gameList = [];
        ARIS_GAMES.forEach((entry) => {
            if (authenticated || !entry.inDev) {
                gameList.push(entry.name);
            }
        });
        setGameList(gameList);
    }, [authenticated]);

    const launchSuccess = (res) => {
        const credentials = JSON.parse(res).Credentials;

        const token = {
            "brand": "MandarinPalace",
            "locale": "en-US",
            "currency": "USD",
            "playmode": "Real",

            "service_url": `https://play${serviceId}.aristx.net/services`,
            "webapp_url": `https://play${serviceId}.aristx.net/MandarinPalace/en-US/webapps`,
            "return_url": `https://demo-kore${serviceId}.aristx-external.net/MandarinPalace`,

            "session_id": credentials.SessionID,
            "user_token": credentials.UserToken,
            "game_name": `${game}VideoSlot`,
            "game_id": ARIS_ENGINE_REPLACEMENTS[`${game}VideoSlot`]
                ? ARIS_ENGINE_REPLACEMENTS[`${game}VideoSlot`]
                : `${game}VideoSlot`,
        };

        const url = `${authenticated ? env : envList["Stage"]}?token=${btoa(JSON.stringify(token))}`;
        setSafariBackup(url);
        window.open(url, "_blank").focus();
    };

    const launchFail = (res) => {
        console.error(res);
        window.alert("Error Launching Game: Check console for error log");
    };

    const launchGame = () => {
        if (game == "Select Game") {
            return alert("Whoops! You need to select a game you silly goose.");
        }

        const server = `https://play${serviceId}.aristx.net/Services/UserService/Login`;

        const launchRequest = {
            email: `test${authenticated ? Number(userIndex) + 1 : 24}@crucible.com`,
            password: "test1234",
            brand: "MandarinPalace",
            siteLocale: "en-US",
        };

        comms.doPost(server, JSON.stringify(launchRequest), launchSuccess, launchFail);
    };

    return (
        <main>
            <div className="dev-section">
                <h1>Aris Launcher</h1>
                <div className="dev-container">
                    {authenticated && (
                        <div className="dev-item">
                            Log In As:
                            <br />
                            <select
                                id="useraccount"
                                name="user"
                                onChange={(e) => {
                                    setUserIndex(e.target.value);
                                }}
                                value={userIndex}
                            >
                                {userList.map((option, index) => (
                                    <option key={option} value={index}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="dev-item">
                        Game:
                        <br />
                        <select
                            id="gamefolder"
                            name="gameFolder"
                            onChange={(e) => setGame(e.target.value)}
                            value={game}
                        >
                            {gameList.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="dev-item">
                        Service ID:
                        <br />
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <p style={{ fontWeight: "normal" }}>aristxPLAY-</p>
                            <input
                                id="service"
                                type="number"
                                name="service"
                                onChange={(e) => setServiceId(e.target.value)}
                                value={serviceId}
                                style={{ maxWidth: "50px" }}
                            />
                        </div>
                    </div>
                    {authenticated && (
                        <div className="dev-item">
                            Environment:
                            <br />
                            <select
                                id="launchLoc"
                                name="launchLocation"
                                onChange={(e) => setEnv(e.target.value)}
                                value={env}
                            >
                                {Object.keys(envList).map((envKey) => (
                                    <option key={envKey} value={envList[envKey]}>
                                        {envKey}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="dev-item flex-align-center">
                        Launch!
                        <br />
                        <button id="goCloud" onClick={launchGame}>
                            Launch Game
                        </button>
                        {safariBackup && (
                            <a href={safariBackup} target="_blank" rel="noopener noreferrer">
                                Safari Launcher Backup
                            </a>
                        )}
                    </div>
                </div>
                {authenticated && (
                    <>
                        <span className="spacer"></span>
                        <h1>External Links</h1>
                        <div className="dev-container">
                            <a className="external-item" href={testSite} target="_blank">
                                Aris Kore {serviceId}
                            </a>
                            <a className="external-item" href={`https://fixi${serviceId}.aristx.net/`} target="_blank">
                                Fixi{serviceId} (Forces)
                            </a>
                            <a
                                className="external-item"
                                href={`https://godtest-saucify${serviceId}.aristx.net/`}
                                target="_blank"
                            >
                                Games on Demand {serviceId}
                            </a>
                            <a
                                className="external-item"
                                href={`https://godfixedresults-saucify${serviceId}.aristx.net/Default.aspx`}
                                target="_blank"
                            >
                                GOD Fixed Results {serviceId}
                            </a>
                        </div>
                    </>
                )}
            </div>
        </main>
    );
};

export default Aris;